/**
 * Abre o WhatsApp sem ser bloqueado pelo navegador: a aba é aberta no clique
 * (gesto do usuário) e recebe a URL quando a API responde.
 */
export async function abrirWhatsapp(obterUrl: () => Promise<string>): Promise<void> {
  const aba = window.open('about:blank', '_blank');
  try {
    const url = await obterUrl();
    if (aba) {
      aba.opener = null;
      aba.location.href = url;
    } else {
      window.location.href = url; // bloqueador de pop-up: abre na mesma aba
    }
  } catch (e) {
    aba?.close();
    throw e;
  }
}

/**
 * Abre um link whatsapp:// no app WhatsApp Desktop. Precisa ser chamado dentro de um gesto
 * do usuário (clique/tecla). A página do CRM não sai do lugar.
 * Resolve `true` se a janela perdeu o foco (o app abriu) em até 2 s.
 */
export function abrirNoApp(url: string): Promise<boolean> {
  return new Promise((resolve) => {
    let abriu = false;
    const blur = () => {
      abriu = true;
    };
    window.addEventListener('blur', blur, { once: true });
    window.location.href = url;
    setTimeout(() => {
      window.removeEventListener('blur', blur);
      resolve(abriu || document.visibilityState === 'hidden');
    }, 2000);
  });
}
